<div class="pending-proposal__wrapper">
  <img src='/assets/images/proposal-status/pending.png'>

  <h4 class="pending-proposal__title">
    Essa proposta foi submetida a análise manual. Acompanhe o status na lista de propostas.
  </h4>
</div>
<fd-button [content]="'Voltar para o início'" (trigger)="navigateToHome()">
</fd-button>
